var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEllipseFilled = function SvgEllipseFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.871 11.187C.264 6.956.534.085 10.345.326c9.81.241 15.486 4.854 16.093 9.085.607 4.232-1.01 9.104-7.69 10.062-6.681.959-16.388-3.636-17.877-8.286z"
  })));
};
export default SvgEllipseFilled;